export const selectSellers = (state) => state?.sellers?.sellers?.sort((a,b) => a.nome.localeCompare(b.nome));

export const selectTypeDocs = (state) => state.sellers.typeDocs;